import React from "react";

export const { Provider, Consumer } = React.createContext({
  isOpen: false,
  onClose: null
});
